"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var SvgIcon_1 = require("./internal/SvgIcon");

exports.Add = function (props) {
  return react_1.default.createElement(SvgIcon_1.SvgIcon, tslib_1.__assign({}, props), react_1.default.createElement("svg", {
    viewBox: "0 0 16 16"
  }, react_1.default.createElement("path", {
    d: "M9 3H7V7H3V9H7V13H9V9H13V7H9V3Z"
  })));
};